import { Box, Button } from '@mui/material';
import FactoryIcon from '@mui/icons-material/Factory';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

interface ActionButtonsProps {
  onEdit: () => void;
  onDelete: () => void;
  onDeliver: () => void;
  isDeleting?: boolean;
  orderId: string;
  isDelivered?: boolean; 
}

export function ActionButtons({ onEdit, onDelete, onDeliver, isDeleting, isDelivered }: ActionButtonsProps) {
  const disabled = isDeleting || isDelivered;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<FactoryIcon />}
        sx={{
          fontWeight: 700,
          fontSize: 16,
          borderRadius: 8,
          px: 4,
          py: 1.5,
          textTransform: 'none',
          boxShadow: 'none',
          minWidth: 180
        }}
        onClick={onEdit}
        disabled={disabled}
      >
        Editar Encomenda
      </Button>
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteOutlineIcon />}
        sx={{
          fontWeight: 700,
          fontSize: 16,
          borderRadius: 8,
          px: 4,
          py: 1.5,
          textTransform: 'none',
          boxShadow: 'none',
          bgcolor: '#FFF0F0',
          minWidth: 180,
          '&:hover': {
            bgcolor: '#FFE5E5',
            borderColor: '#F3D1D1'
          }
        }}
        onClick={onDelete}
        disabled={disabled}
      >
        Excluir Encomenda
      </Button>
      <Button
        variant="contained"
        color="secondary"
        startIcon={<LocalShippingIcon />}
        onClick={onDeliver}
        disabled={disabled}
        sx={{
          fontWeight: 700,
          fontSize: 16,
          borderRadius: 8,
          px: 4,
          py: 1.5,
          textTransform: 'none',
          boxShadow: 'none',
          minWidth: 180
        }}
      >
        Entregar/Retirar
      </Button>
    </Box>
  );
}